"use client";
import { useEffect } from "react";
import emitter from "@packages/lib/eventEmitter/eventEmitter";
export default function BrowserNavigationListner() {
  useEffect(() => {
    // Assign an index to history state if missing
    if (!history.state || typeof history.state.index !== "number") {
      history.replaceState({ index: 0 }, "");
    }

    let currentIndex = history.state.index;

    const handleNavigation = () => {
      const newIndex = history.state?.index;

      if (newIndex < currentIndex) {
        emitter.emit("refreshFilters");
      } else if (newIndex > currentIndex) {
        emitter.emit("refreshFilters");
      } else {
        emitter.emit("refreshFilters");
      }

      currentIndex = newIndex;
    };

    window.addEventListener("popstate", handleNavigation);

    return () => {
      window.removeEventListener("popstate", handleNavigation);
    };
  }, []);

  return null;
}
